import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REGISTER_SIZE, ROUTE_CONFIRM_EMAIL } from 'common/constants';
import { Link } from 'react-router-dom';
import { Input, Checkbox, Button } from 'common/components';
import { AuthScreen, TCModal } from 'containers';
import { history } from 'store';
import { auth } from 'actions';
import {
  email,
  required,
  numberOnly,
  minLength,
  noSpace,
  minValue,
  maxValue,
  hasDigit,
  hasCapital,
  hasLower,
} from 'common/form-validators';
import * as normalizers from 'common/normalizers';
import { toCommaNumber } from 'common/formatters';
import mixpanel from 'mixpanel-browser';

import './index.css';

class Register extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      error: null,
    };

    // validations
    this.minPasswordLength = minLength(REGISTER_SIZE.MIN_PASSWORD);
    this.farmSizeMin = value => minValue(value, REGISTER_SIZE.MIN);
    this.farmSizeMax = value => maxValue(value, REGISTER_SIZE.MAX);

    // normlizers
    this.normalizeFarmSize = value =>
      normalizers.limitDigits(normalizers.onlyNumbers(value), 13);
  }

  toggleModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  handleTCClick = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ modal: true });
  };

  register = async values => {
    try {
      await this.props.register(values);
      mixpanel.alias(values.email);
      history.push(ROUTE_CONFIRM_EMAIL);
    } catch (error) {
      this.setState({ error: error.errors._error });
    }
  };

  render() {
    const { handleSubmit, valid, pristine, submitting } = this.props;
    const { error } = this.state;
    return (
      <AuthScreen
        header={
          <Fragment>
            <h1 className={'text--header'}>SIGN UP</h1>
            <span className={'text---fade'}>
              or <Link to="/">Sign in</Link>
            </span>
          </Fragment>
        }
      >
        <form onSubmit={handleSubmit(this.register)}>
          <Input
            name="firstName"
            title="First Name"
            validate={[required]}
            disabled={submitting}
            normalizeOnBlur={normalizers.trim}
          />

          <Input
            name="lastName"
            title="Last Name"
            validate={[required]}
            disabled={submitting}
            normalizeOnBlur={normalizers.trim}
          />

          <Input
            name="email"
            type="email"
            validate={[email, required]}
            title="Email"
            disabled={submitting}
          />

          <Input
            name="registerPassword"
            type="password"
            title="Password"
            validate={[
              required,
              noSpace,
              this.minPasswordLength,
              hasCapital,
              hasLower,
              hasDigit,
            ]}
            disabled={submitting}
          />

          <header className="register__farm-details">
            <h2 className={'text--header'}>
              Farm Details
              <small>(optional)</small>
            </h2>
          </header>

          <Input
            name="farmAddress"
            title="Address"
            disabled={submitting}
            normalizeOnBlur={normalizers.trim}
          />

          <Input
            name="farmSize"
            title="Farm Size"
            normalize={this.normalizeFarmSize}
            validate={[numberOnly, this.farmSizeMin, this.farmSizeMax]}
            format={toCommaNumber}
            disabled={submitting}
            infoText={'Acres'}
          />

          <Checkbox
            name="termsAgreed"
            label={
              <Fragment>
                By selecting this checkbox, you agree to our{' '}
                <a
                  onClick={this.handleTCClick}
                  title={'Terms and Cookies Policy'}
                >
                  Terms and Cookies Policy
                </a>
                . You may receive email notifications from us and can opt out
                any time.
              </Fragment>
            }
            disabled={submitting}
            className={'text--small'}
          />

          {error && <p className={'text--error'}>{error}</p>}

          <div className={'field__group text--center'}>
            <Button
              type="submit"
              className="btn btn--primary"
              disabled={!valid || pristine || submitting}
            >
              CREATE ACCOUNT
            </Button>
          </div>
        </form>

        {this.state.modal && <TCModal onToggle={this.toggleModal} />}
      </AuthScreen>
    );
  }
}

Register.propTypes = {
  error: PropTypes.string,
  register: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const mapDispatch = {
  register: auth.register,
};

const enhance = compose(
  connect(
    null,
    mapDispatch
  ),
  reduxForm({
    form: 'register',
  })
);

export { Register };

export default enhance(Register);



// WEBPACK FOOTER //
// ./src/pages/Register/index.js